import { Box, Switch, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { updateBadgeVisibleEffect } from 'app/store/Settings/effects';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getSettingsSelector } from 'app/store/Settings/selectors';

export const AppSettings = () => {
  const dispatch = useAppDispatch();
  const settings = useAppSelector(getSettingsSelector);
  const styles = useMultiStyleConfig('SettingsPageList', {});

  const updateBadge = () =>
    dispatch(updateBadgeVisibleEffect({ visible: !settings.badge.visible }));

  return (
    <Box sx={styles.container}>
      <Box sx={styles.textWrapper}>
        <Text sx={styles.primaryText} pt={2}>
          DAW Badge
        </Text>
        <Text sx={styles.secondaryText}>
          Show the Session Studio Badge in your DAW
        </Text>
      </Box>
      <Switch isChecked={settings.badge.visible} onChange={updateBadge} />
    </Box>
  );
};
